import { render, staticRenderFns } from "./studentmanage.vue?vue&type=template&id=45ad9d3d&scoped=true&"
import script from "./studentmanage.vue?vue&type=script&lang=js&"
export * from "./studentmanage.vue?vue&type=script&lang=js&"
import style0 from "./studentmanage.vue?vue&type=style&index=0&id=45ad9d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad9d3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ad9d3d')) {
      api.createRecord('45ad9d3d', component.options)
    } else {
      api.reload('45ad9d3d', component.options)
    }
    module.hot.accept("./studentmanage.vue?vue&type=template&id=45ad9d3d&scoped=true&", function () {
      api.rerender('45ad9d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/studentmanage.vue"
export default component.exports